<section class="articles-section">
  <span #articles class="visually-hidden"></span>
  <div class="width-wrapper">
    <h2 class="articles-title">О нас пишут</h2>
    <div class="articles-wrapper">

      <div class="article-item">
        <a class="article-img-Rusbase" target="_blank" href="https://rb.ru/traveltech-map/analytics-tour-operators/">
          <img class=""
               src="../../../assets/img/article1.png"
               alt="TravelTech-рынок"
               width="466"
               height="210">
        </a>
        <div class="text-wrapper">
          <p class="article-text">Мы на карте TravelTech-рынка России</p>
          <a class="follow" target="_blank" href="https://rb.ru/traveltech-map/analytics-tour-operators/">Перейти</a>
        </div>
      </div>

      <div class="article-item">
        <a class="article-img-ThinkTravelTech" target="_blank" href="https://thinktraveltech.com/news/startup/travelsyspro">
          <img class=""
               src="../../../assets/img/article2.png"
               alt="Think travel tech"
               width="466"
               height="210">
        </a>
        <div class="text-wrapper">
          <p class="article-text">Менеджер в турагентстве должен общаться с клиентом. Остальное может делать робот</p>
          <a class="follow" target="_blank" href="https://thinktraveltech.com/news/startup/travelsyspro">Перейти</a>
        </div>

      </div>

      <div class="article-item">
        <a class="article-img-Rusbase" target="_blank" href="https://rb.ru/news/best-travel-startups/">
          <img class=""
               src="../../../assets/img/article3.png"
               alt="Rusbase"
               width="467"
               height="210">
        </a>
        <div class="text-wrapper">
          <p class="article-text">Объявлены лучшие тревел-стартапы «Фабрики туристических продуктов и сервисов»</p>
          <a class="follow" target="_blank" href="https://rb.ru/news/best-travel-startups/">Перейти</a>
        </div>
      </div>

    </div>
  </div>
</section>
